// extracted by mini-css-extract-plugin
export default {"list":"banner1_list__1X1cM","span_text":"banner1_span_text__wbFiT","margins":"banner1_margins__pnm8n"};